(() => {
  function configureInquiry(dialog, quoteTrigger) {
    const isBackorder = Boolean(quoteTrigger);
    dialog.querySelector('[data-inquiry-default-title]').hidden = isBackorder;
    dialog.querySelector('[data-inquiry-backorder-title]').hidden = !isBackorder;
    dialog.querySelector('[data-inquiry-default-intro]').hidden = isBackorder;
    dialog.querySelector('[data-inquiry-backorder-intro]').hidden = !isBackorder;
    const context = dialog.querySelector('[data-inquiry-product-context]');
    const backorderFields = dialog.querySelector('[data-backorder-fields]');
    const productTitle = dialog.querySelector('#InquiryProductTitle');
    const variantTitle = dialog.querySelector('#InquiryVariant');
    const productUrl = dialog.querySelector('#InquiryProductURL');
    const sku = dialog.querySelector('#InquirySKU');
    const quoteInputs = backorderFields.querySelectorAll('input, select');
    context.hidden = !isBackorder;
    backorderFields.hidden = !isBackorder;
    [productTitle, variantTitle, productUrl].forEach(input => { input.disabled = !isBackorder; });
    quoteInputs.forEach(input => {
      input.disabled = !isBackorder;
      input.required = isBackorder;
    });
    if (!isBackorder) {
      productTitle.value = '';
      variantTitle.value = '';
      productUrl.value = '';
      sku.value = '';
      return;
    }
    productTitle.value = quoteTrigger.dataset.productTitle || '';
    variantTitle.value = quoteTrigger.dataset.variantTitle || '';
    productUrl.value = quoteTrigger.dataset.productUrl || window.location.href;
    sku.value = quoteTrigger.dataset.sku || '';
    context.querySelector('[data-inquiry-product-title]').textContent = productTitle.value;
    const option = context.querySelector('[data-inquiry-product-option]');
    option.textContent = variantTitle.value ? ` — ${variantTitle.value}` : '';
    const sourceQuantity = document.getElementById(quoteTrigger.dataset.quantityTarget)?.value || '1';
    const requestedQuantity = Number(sourceQuantity);
    dialog.querySelector('#InquiryQuantity').value = Number.isInteger(requestedQuantity) && requestedQuantity >= 1 && requestedQuantity <= 99 ? String(requestedQuantity) : '1';
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-build-explorer]').forEach(explorer => {
      if (explorer.dataset.ready) return;
      explorer.dataset.ready = 'true';
      const tabs = [...explorer.querySelectorAll('[data-build-tab]')];
      const activate = tab => {
        tabs.forEach(t => { const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
        explorer.querySelectorAll('[role="tabpanel"]').forEach(p => p.hidden = p.id !== tab.dataset.buildTab);
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (i + 1) % tabs.length;
          if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
        });
      });
    });
    root.querySelectorAll('[data-product-variant-select]').forEach(select => {
      if (select.dataset.stockReady) return;
      select.dataset.stockReady = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const purchase = select.closest('[data-product-purchase]');
        const stock = purchase?.querySelector('[data-stock-status]');
        const submit = purchase?.querySelector('[data-product-submit]');
        const quote = purchase?.querySelector('[data-backorder-quote]');
        const quoteNote = purchase?.querySelector('[data-backorder-note]');
        if (stock && option) {
          stock.dataset.stockState = option.dataset.stockState;
          stock.querySelector('[data-stock-label]').textContent = option.dataset.stockLabel;
        }
        if (submit && option) {
          const available = option.dataset.available === 'true';
          submit.disabled = !available;
          submit.hidden = !available;
          submit.textContent = available ? submit.dataset.addLabel : submit.dataset.unavailableLabel;
        }
        if (quote && option) {
          const available = option.dataset.available === 'true';
          quote.hidden = available;
          quote.dataset.sku = option.dataset.sku || '';
          quote.dataset.variantTitle = option.dataset.variantTitle || '';
          if (quoteNote) quoteNote.hidden = available;
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  let opener;
  document.addEventListener('click', e => {
    const brandFilter = e.target.closest('[data-brand-filter]');
    if (brandFilter) {
      const group = brandFilter.closest('[data-brand-explorer]');
      const selected = brandFilter.dataset.brandFilter;
      group.querySelectorAll('[data-brand-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === brandFilter)));
      let count = 0;
      group.querySelectorAll('[data-brand-group]').forEach(card => {
        card.hidden = selected !== 'all' && card.dataset.brandGroup !== selected;
        if (!card.hidden) count++;
      });
      group.querySelector('[data-brand-count]').textContent = `${count} featured brands`;
    }
    const open = e.target.closest('[data-open-inquiry]');
    const dialog = document.getElementById('AtlasInquiry');
    if (open && dialog) { opener = open; configureInquiry(dialog, open.matches('[data-backorder-quote]') ? open : null); dialog.showModal(); document.body.classList.add('dialog-open'); }
    if (e.target.closest('[data-close-inquiry]') && dialog) dialog.close();
    const toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) { const expanded = toggle.getAttribute('aria-expanded') === 'true'; toggle.setAttribute('aria-expanded', String(!expanded)); document.getElementById('MainNavigation')?.classList.toggle('is-open', !expanded); }
  });
  const dialog = document.getElementById('AtlasInquiry');
  if (dialog) {
    dialog.addEventListener('close', () => { document.body.classList.remove('dialog-open'); opener?.focus(); });
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
    if (dialog.querySelector('.form-success, .errors')) dialog.showModal();
  }
})();
